module.exports = __webpack_public_path__ + "img/ys_1.11489e7b.png";